import React from 'react';

import SubscriptionSetupContainer from './SubscriptionSetupContainer';
import { SubscriptionSetupProvider } from './SubscriptionSetupContext';

const SubscriptionSetup = () => {
  return (
    <SubscriptionSetupProvider>
      <SubscriptionSetupContainer />
    </SubscriptionSetupProvider>
  );
};

export default SubscriptionSetup;
